<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-6">{{ year }} © Audit Management System</div>
      <div class="col-sm-6">
        <div class="text-sm-right d-none d-sm-block">
          Powered by Digital Innova
        </div>
      </div>
    </div>
  </div>
</footer>
